export default function c0coordinates(x, y) {
  this.c0.x = x;
  this.c0.y = y;
}
